import chord from "~/utils/chord";

window.getCartContents = async function getCartContents() {
  const cartContents = await fetch(window.Shopify.routes.root + "cart.js")
    .then(response => response.json())
    .then(data => {
      return data;
    })
    .catch(error => {
      console.log(error);
    });
  return cartContents;
};

window.TrackProductViewed = function TrackProductViewed(order, product, customer, variantId) {
  const selectedVariant = getVariant(product, variantId);
  chord.typewriter.productViewed({
    meta: chord.meta,
    ...(order && {
      ...(order.id && { order_id: order.id.toString() }),
      ...(order.name && { order_name: order.name })
    }),
    ...(product && {
      ...(product.description && { product_description: product.description }),
      product_id: product.id.toString(),
      product_image_url: product.featured_image,
      product_name: product.title,
      product_slug: product.handle,
      price: formatPrice(product.price),
      product_variant_id: selectedVariant.id,
      product_variant_sku: selectedVariant.sku,
      sku: selectedVariant.sku,
      product_variant_price: formatPrice(selectedVariant.price),
      ...(selectedVariant.title && { product_variant_title: selectedVariant.title }),
      ...(selectedVariant.title && { variant: selectedVariant.title })
    }),
    ...(customer && {
      ...(customer.name && { user_display_name: customer.name }),
      ...(customer.email && { user_email: customer.email }),
      ...(customer.first_name && { user_first_name: customer.first_name }),
      ...(customer.id && { user_id: customer.id.toString() }),
      ...(customer.last_name && { user_last_name: customer.last_name }),
      ...(customer.phone && { user_phone: customer.phone })
    })
  });
};

window.TrackProductClicked = function TrackProductClicked(order, product, customer, placement, position) {
  const selectedVariant = product?.variants[0];
  chord.typewriter.productClicked({
    meta: chord.meta,
    ...(order && {
      ...(order.id && { order_id: order.id.toString() }),
      ...(order.name && { order_name: order.name })
    }),
    ...(product && {
      ...(product.description && { product_description: product.description }),
      product_id: product.id.toString(),
      product_image_url: product.featured_image,
      product_name: product.title,
      product_slug: product.handle,
      ...(placement && { product_placement: placement }),
      ...(position && { product_position: parseInt(position) }),
      price: formatPrice(product.price),
      product_variant_id: selectedVariant.id,
      product_variant_sku: selectedVariant.sku,
      sku: selectedVariant.sku,
      product_variant_price: formatPrice(selectedVariant.price),
      price: formatPrice(selectedVariant.price),
      ...(selectedVariant.title && { product_variant_title: selectedVariant.title }),
      ...(selectedVariant.title && { variant: selectedVariant.title })
    }),
    ...(customer && {
      ...(customer.name && { user_display_name: customer.name }),
      ...(customer.email && { user_email: customer.email }),
      ...(customer.first_name && { user_first_name: customer.first_name }),
      ...(customer.id && { user_id: customer.id.toString() }),
      ...(customer.last_name && { user_last_name: customer.last_name }),
      ...(customer.phone && { user_phone: customer.phone })
    })
  });
};

window.TrackProductAdded = function TrackProductAdded(
  order,
  product,
  customer,
  currency,
  quantity,
  placement,
  position,
  variantId
) {
  const selectedVariant = getVariant(product, variantId);
  chord.typewriter.productAdded({
    currency: currency,
    meta: chord.meta,
    ...(order && {
      ...(order.id && { order_id: order.id.toString() }),
      ...(order.name && { order_name: order.name })
    }),
    ...(product && {
      ...(product.description && { product_description: product.description }),
      product_id: product.id.toString(),
      product_image_url: product.featured_image,
      product_name: product.title,
      product_slug: product.handle,
      ...(placement && { product_placement: placement }),
      ...(position && { product_position: position }),
      product_quantity: quantity,
      price: formatPrice(product.price),
      product_variant_id: selectedVariant.id,
      product_variant_sku: selectedVariant.sku,
      sku: selectedVariant.sku,
      product_variant_price: formatPrice(selectedVariant.price),
      ...(selectedVariant.title && { product_variant_title: selectedVariant.title }),
      ...(selectedVariant.title && { variant: selectedVariant.title })
    }),
    ...(customer && {
      ...(customer.name && { user_display_name: customer.name }),
      ...(customer.email && { user_email: customer.email }),
      ...(customer.first_name && { user_first_name: customer.first_name }),
      ...(customer.id && { user_id: customer.id.toString() }),
      ...(customer.last_name && { user_last_name: customer.last_name }),
      ...(customer.phone && { user_phone: customer.phone })
    })
  });
};

window.TrackProductRemoved = function TrackProductRemoved(order, product, customer, currency, quantity, variantId) {
  const selectedVariant = getVariant(product, variantId);
  chord.typewriter.productRemoved({
    currency: currency,
    meta: chord.meta,
    ...(order && {
      ...(order.id && { order_id: order.id.toString() }),
      ...(order.name && { order_name: order.name })
    }),
    ...(product && {
      ...(product.description && { product_description: product.description }),
      product_id: product.id.toString(),
      product_image_url: product.featured_image,
      product_name: product.title,
      product_slug: product.handle,
      product_quantity: quantity,
      price: formatPrice(product.price),
      product_variant_id: selectedVariant.id,
      product_variant_sku: selectedVariant.sku,
      sku: selectedVariant.sku,
      product_variant_price: formatPrice(selectedVariant.price),
      ...(selectedVariant.title && { product_variant_title: selectedVariant.title }),
      ...(selectedVariant.title && { variant: selectedVariant.title })
    }),
    ...(customer && {
      ...(customer.name && { user_display_name: customer.name }),
      ...(customer.email && { user_email: customer.email }),
      ...(customer.first_name && { user_first_name: customer.first_name }),
      ...(customer.id && { user_id: customer.id.toString() }),
      ...(customer.last_name && { user_last_name: customer.last_name }),
      ...(customer.phone && { user_phone: customer.phone })
    })
  });
};

window.TrackProductUpdated = function TrackProductUpdated(order, product, customer, currency, quantity, variantId) {
  const selectedVariant = getVariant(product, variantId);
  chord.typewriter.productUpdated({
    currency: currency,
    meta: chord.meta,
    ...(order && {
      ...(order.id && { order_id: order.id.toString() }),
      ...(order.name && { order_name: order.name })
    }),
    ...(product && {
      ...(product.description && { product_description: product.description }),
      product_id: product.id.toString(),
      product_image_url: product.featured_image,
      product_name: product.title,
      product_quantity: quantity,
      product_slug: product.handle,
      price: formatPrice(product.price),
      product_variant_id: selectedVariant.id,
      product_variant_sku: selectedVariant.sku,
      sku: selectedVariant.sku,
      product_variant_price: formatPrice(selectedVariant.price),
      ...(selectedVariant.title && { product_variant_title: selectedVariant.title }),
      ...(selectedVariant.title && { variant: selectedVariant.title })
    }),
    ...(customer && {
      ...(customer.name && { user_display_name: customer.name }),
      ...(customer.email && { user_email: customer.email }),
      ...(customer.first_name && { user_first_name: customer.first_name }),
      ...(customer.id && { user_id: customer.id.toString() }),
      ...(customer.last_name && { user_last_name: customer.last_name }),
      ...(customer.phone && { user_phone: customer.phone })
    })
  });
};

window.TrackProductListViewed = function TrackProductListViewed(collection) {
  chord.typewriter.productListViewed({
    meta: chord.meta,
    product_list_category: collection.title,
    product_list_id: collection.id.toString()
  });
};

window.TrackCartViewed = function TrackCartViewed(order, cart, customer) {
  let cartItems = [];
  let skuList = '';
  let quantityList = '';
  if (cart?.items?.length > 0) {
    cartItems = cart?.items?.map(item => ({
      ...(item.description && { product_description: item.product_description }),
      product_id: item.product_id.toString(),
      product_image_url: item.featured_image.url,
      product_name: item.product_title,
      product_slug: item.handle,
      product_quantity: item.quantity,
      price: formatPrice(item.price),
      product_variant_price: formatPrice(item.price),
      product_variant_id: item.variant_id,
      product_variant_sku: item.sku,
      sku: item.sku,
      ...(item.title && { product_variant_title: item.title }),
      ...(item.title && { variant: item.title })
    }));

    skuList = getSkuList(cart.items);
    quantityList = getQuantityList(cart.items);
  }
  chord.typewriter.cartViewed({
    currency: cart.currency,
    meta: chord.meta,
    ...(order && {
      ...(order.id && { order_id: order.id.toString() }),
      ...(order.name && { order_name: order.name })
    }),
    products: cartItems,
    ...(skuList.length && { sku_list: skuList }),
    ...(quantityList.length && { quantity_list: quantityList }),
    ...(customer && {
      ...(customer.name && { user_display_name: customer.name }),
      ...(customer.email && { user_email: customer.email }),
      ...(customer.first_name && { user_first_name: customer.first_name }),
      ...(customer.id && { user_id: customer.id.toString() }),
      ...(customer.last_name && { user_last_name: customer.last_name }),
      ...(customer.phone && { user_phone: customer.phone })
    })
  });
};

window.TrackCheckoutStarted = function TrackCheckoutStarted(order, cart, customer) {
  let cartItems = [];
  let skuList = '';
  let quantityList = '';
  if (cart?.items?.length > 0) {
    cartItems = cart?.items?.map(item => ({
      ...(item.description && { product_description: item.product_description }),
      product_id: item.product_id.toString(),
      product_image_url: item.featured_image.url,
      product_name: item.product_title,
      product_slug: item.handle,
      product_quantity: item.quantity,
      product_price: formatPrice(item.price),
      price: formatPrice(item.price),
      product_variant_id: item.variant_id,
      product_variant_sku: item.sku,
      sku: item.sku,
      ...(item.title && { product_variant_title: item.title }),
      ...(item.title && { variant: item.title })
    }));
    skuList = getSkuList(cart.items);
    quantityList = getQuantityList(cart.items);
  }
  chord.typewriter.checkoutStarted({
    meta: chord.meta,
    ...(order && {
      ...(order.id && { order_id: order.id.toString() }),
      ...(order.name && { order_name: order.name })
    }),
    products: cartItems,
    ...(skuList.length && { sku_list: skuList }),
    ...(quantityList.length && { quantity_list: quantityList }),
    ...(customer && {
      ...(customer.name && { user_display_name: customer.name }),
      ...(customer.email && { user_email: customer.email }),
      ...(customer.first_name && { user_first_name: customer.first_name }),
      ...(customer.id && { user_id: customer.id.toString() }),
      ...(customer.last_name && { user_last_name: customer.last_name }),
      ...(customer.phone && { user_phone: customer.phone })
    })
  });
};

window.TrackCollectionClicked = function TrackCollectionClicked(collection) {
  chord.typewriter.collectionClicked({
    ...(collection && {
      ...(collection.description && { collection_description: collection.description }),
      collection_id: collection.id.toString(),
      ...(collection.featured_image && { collection_featured_image: collection.featured_image.url }),
      collection_slug: collection.handle,
      collection_name: collection.title
    }),
    meta: chord.meta
  });
};

window.TrackEmailCaptured = function TrackEmailCaptured(email, placementComponent, placementPage) {
  chord.typewriter.emailCaptured({
    email: email,
    meta: chord.meta,
    ...(placementComponent && { placement_component: placementComponent }),
    ...(placementPage && { placement_page: placementPage })
  });
  window.analytics?.identify({
    email: email
  });
};

window.TrackProductListFiltered = function TrackProductListFiltered(
  collection,
  filterType,
  filterValue,
  sortType,
  sortValue
) {
  chord.typewriter.productListFiltered({
    meta: chord.meta,
    product_list_category: collection.title,
    product_list_filter_type: filterType,
    product_list_filter_value: filterValue,
    product_list_id: collection.id.toString(),
    product_list_sort_type: sortType,
    product_list_sort_value: sortValue
  });
};

window.TrackCTABestBuyRX = function TrackCTABestBuyRX() {
  window.analytics?.track("CTA - Best Buy RX", {
    meta: chord.meta,
    label: "BBY-RX-Red-PDP"
  });
};
window.TrackCTAIndianHooligan = function TrackCTAIndianHooligan() {
  window.analytics?.track("CTA - Indian Hooligan", {
    meta: chord.meta,
    label: "Indian-PDP"
  });
};
window.TrackCTAFindADealer = function TrackCTAFindADealer(title) {
  window.analytics?.track("CTA - Find a Dealer", {
    meta: chord.meta,
    label: title
  });
};
window.TrackCTAC1XJoinTheJourney = function TrackCTAC1XJoinTheJourney(location) {
  window.analytics?.track("CTA - C1X Join the Journey", {
    meta: chord.meta,
    label: location
  });
};
window.TrackCTAYouthSubscribeNow = function TrackCTAYouthSubscribeNow(location) {
  window.analytics?.track("CTA - Youth Subscribe Now", {
    meta: chord.meta,
    label: location
  });
};
window.TrackCTAIdMe = function TrackCTAIdMe(location) {
  window.analytics?.track("CTA - ID.ME", {
    meta: chord.meta,
    label: location
  });
};

window.IdentifyUser = function IdentifyUser(customer) {
  window.analytics?.identify(customer.id, {
    id: customer.id,
    email: customer.email,
    first_name: customer.first_name,
    last_name: customer.last_name,
    name: customer.name,
    display_name: customer.name,
    ...(customer.phone && { phone: customer.phone }),
    ...(customer.default_address?.company && {
      company: {
        name: customer.default_address?.company
      }
    }),
    ...(customer.default_address?.id && {
      address: {
        address_id: customer.default_address.id,
        address_first_name: customer.default_address.first_name,
        address_last_name: customer.default_address.last_name,
        address_address_1: customer.default_address.address1,
        ...(customer.default_address.address2 && { address_address_2: customer.default_address.address2 }),
        address_city: customer.default_address.city,
        address_state: customer.default_address.province,
        address_country: customer.default_address.country,
        ...(customer.default_address.company && { address_company: customer.default_address.company }),
        address_zip: customer.default_address.zip,
        ...(customer.default_address.phone && { address_phone: customer.default_address.phone }),
        address_is_default: true
      }
    })
  });
};

// Utilities
window.getVariant = function getVariant(product, variantId) {
  const firstVariant = product?.variants[0];
  const matchedVariant = product?.variants?.find(variant => variant.id == parseInt(variantId));
  return matchedVariant ? matchedVariant : firstVariant;
};
window.formatPrice = function formatPrice(rawPrice) {
  return parseInt((rawPrice / 100).toFixed(2));
};
window.getSkuList = function getSkuList(variants) {
  const skuArr = variants.map(variant => variant.sku);
  return skuArr.toString();
};
window.getQuantityList = function getQuantityList(variants) {
  const qtyArr = variants.map(variant => variant.quantity);
  return qtyArr.toString();
};
